export type DateTime = Date | string | number;

export enum DateTimePartsEnum {
  DAY = 'day',
  HOUR = 'hour',
  MILLISECOND = 'millisecond',
  MINUTE = 'minute',
  MONTH = 'month',
  SECOND = 'second',
  YEAR = 'year',
}
